import { HeaderLogo } from '@pelando/components';
import styled from 'styled-components';

export const HeaderLogoEnhanced = styled(HeaderLogo)`
  grid-area: logo;
  display: block;
  margin: 0;
`;
